/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CompanyModal_company = {
    readonly uuid: string;
    readonly name: string;
    readonly contactEmail: string;
    readonly logoURL: string | null;
    readonly address: {
        readonly addressLine1: string;
        readonly addressLine2: string;
        readonly county: string;
        readonly postCode: string;
    };
    readonly " $refType": "CompanyModal_company";
};
export type CompanyModal_company$data = CompanyModal_company;
export type CompanyModal_company$key = {
    readonly " $data"?: CompanyModal_company$data;
    readonly " $fragmentRefs": FragmentRefs<"CompanyModal_company">;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CompanyModal_company",
    "type": "Company",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "uuid",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "contactEmail",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "logoURL",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "address",
            "storageKey": null,
            "args": null,
            "concreteType": "Address",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "addressLine1",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "addressLine2",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "county",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "postCode",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'fa4ddbbedc7bb93cbc0b89542e1fb3c4';
export default node;
